export default "__VITE_ASSET__B0UM_VHO__"